import React from 'react';
import { PdfBorderStyle, PdfStaticTextComponent, PdfTextAlign, PdfVerticalAlign } from '../PdfComponent';
import { usePdfTemplateContext } from '../PdfTemplateEditorContext';

export default function PdfTemplateStaticTextPreview<T>({ component }: { component: PdfStaticTextComponent }) {
  const { fontToCss, documentProperties } = usePdfTemplateContext<T>();

  const borderStyle = (() => {
    switch (component.border.style) {
      case PdfBorderStyle.dashed:
        return 'dashed';
      case PdfBorderStyle.dotted:
        return 'dotted';
      default:
        return 'solid';
    }
  })();

  const justifyContent = (() => {
    switch (component.align) {
      case PdfTextAlign.center:
        return 'center';
      case PdfTextAlign.right:
        return 'flex-end';
      default:
        return 'flex-start';
    }
  })();

  const alignItems = (() => {
    switch (component.valign) {
      case PdfVerticalAlign.middle:
        return 'center';
      case PdfVerticalAlign.bottom:
        return 'flex-end';
      default:
        return 'flex-start';
    }
  })();

  return (
    <div
      className={`flex h-full w-full`}
      style={{
        ...fontToCss(component.font ?? documentProperties.font),
        borderWidth: component.border.enabled ? component.border.width : 0,
        borderColor: component.border.color,
        borderStyle,
        justifyContent: justifyContent,
        alignItems: alignItems,
      }}
    >
      <span>{component.text}</span>
    </div>
  );
}
